export default {
  id: 67,
  title: 'Target #67 - Video Reel',
  url: 'https://cssbattle.dev/play/67',
  colors: ['#191919', '#5DBCF9'],
  solution:
    '<a a><a b><style>body{background:#191919}a{position:fixed;background:#5dbcf9}a[a]{top:0;left:45;width:10;height:300;box-shadow:150px 0 #5dbcf9,300px 0 #5dbcf9}a[b]{top:30;left:50;width:150;height:40;box-shadow:-150px 50px #5dbcf9,-150px 200px #5dbcf9,0 150px #5dbcf9,150px 50px #5dbcf9,150px 200px #5dbcf9,300px 0 #5dbcf9,300px 150px #5dbcf9}</style>',
}
